import './components/timetable'

document.addEventListener('DOMContentLoaded', () => {
  console.log('[HOME] Init')
})
